import React, { useEffect, useState } from 'react' 
import { IFestival, ISettingsPageFormProps } from '../../data/interfaces'
import { Card, Icon, Slider } from '@blueprintjs/core' 
import {__, clearHTML} from '@libs/utilities'
import { Loading, MediaChooser } from '@libs/useful'
import FieldInput from '@libs/scalars'    
import { actions } from '../../data/actions'
import { GET_FESTIVAL_SETTINGS_ACTION } from '../../data/actionTypes'
import { SCALAR_TYPES, VerticalType } from '@libs/scalars/interface/IScalarForm'
import { useAppoloStore } from '@/settings/zustand'
import gql from 'graphql-tag'
import { ID } from '@libs/interfaces/layouts'
import { useFestDataStore } from '../../data/store'
import { useParams } from 'react-router'
import { url } from 'inspector'

const MainPageForm = (props: ISettingsPageFormProps) : JSX.Element => {
    const params = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [festival, setFestival] = useState<IFestival>({} as IFestival) 
    const [defaultFest, setDefaultFest] = useState<string> ("") 
    useEffect(() => {
        actions(GET_FESTIVAL_SETTINGS_ACTION, {id: params.landId})
            .then(
                response => { 
                    setFestival(response)
                    setIsLoading(false)
                    setDefaultFest(JSON.stringify( response ))
                }
            )
        
    },[])
    if( isLoading) return <Loading />
    
    console.log( festival )

    const onValueChange = (field: keyof IFestival, value: any) =>
    {  
        setFestival( {
            ...festival, 
            [field] : value
        } )
    } 
    const onDefaultImage = ( url: string, file: File, ID: ID ) => { 
        let fest: IFestival = {...festival}
        fest.defaultThumbnail = url
        fest.defaultThumbnailName = file?.name
        
        console.log(url)
        console.log(file)
        
        setFestival( fest )
    }
    const updateFestival = () => { 
        const apolloClient: any = useAppoloStore.getState().client
        const land_id = params.landId 
            ?
            ` land_id:"${params.landId}" `
            :
            ``
        const request = `
            mutation changeFestival {
                changePEFestival (
                    input: {
                        enabledRules: ${ festival.enabledRules }
                        isShowReglament: ${ festival.isShowReglament }
                        isShowMap: ${ festival.isShowMap }
                        isShowLaureates: ${ festival.isShowLaureates }
                        isShowSchools: ${ festival.isShowSchools }
                        isShowTracks: ${ festival.isShowTracks }
                        isMilestones: ${ festival.isMilestones }
                        reglamentTitle: "${ festival.reglamentTitle }" 
                        defaultThumbnail: "${ festival.defaultThumbnail }"
                        content: "${ clearHTML(festival.content || "" ) }"
                        reglament: "${ clearHTML(festival.reglament || "" ) }"
                        ${
                            festival.defaultThumbnailName 
                            ?
                            `defaultThumbnailName: "${ festival.defaultThumbnailName }"`
                            :
                            ""
                        }

                        color: "${ festival.color }"
                        link1:"${ festival.link1 }"  
                        link2:"${ festival.link2 }"  
                        vk:"${ festival.vk }"  
                        vk2:"${ festival.vk2 }"
                        email:"${ festival.email }"
                        email2:"${ festival.email2 }" 
                        telegramm:"${ festival.telegramm }" 
                        telegramm2:"${ festival.telegramm2 }"  
                        phone:"${ festival.phone }" 
                        phone2:"${ festival.phone2 }"
                        
                        logotype: "${ festival.logotype }" 
                        ${ festival.logotypeName ? 'logotypeName:"' + festival.logotypeName + '"' : "" } 
                    }
                    ${land_id}
                ) {
                    content
                    reglamentTitle
                    reglament
                    enabledRules
                    isShowReglament
                    isShowMap
                    defaultThumbnail
                    isShowTracks
                    isMilestones
                    isShowLaureates
                    isShowSchools
                    
                    logotype
                    color
                    link1
                    link2
                    vk
                    vk2
                    email
                    email2
                    telegramm
                    telegramm2
                    phone
                    phone2
                }
            }`
        console.log( request )
        apolloClient.mutate({
            mutation : gql`${request}`
        })
        .then( ( response: any ) => {
            console.log( response.data.changePEFestival ) 
            setFestival({
                ...festival,
                ...response.data.changePEFestival 
            })
            setDefaultFest(JSON.stringify( {
                ...festival,
                ...response.data.changePEFestival 
            }))
            useFestDataStore.setState({
                festival: {
                    ...festival,
                    ...response.data.changePEFestival 
                }
            })
        })
    }
    const onIcon = ( url: string, file: any, ID: ID ) =>
	{ 
		setFestival({...festival, logotype: ( url! ), logotypeName: file?.name})
	}
    return (
        <div className="position-relative mb-5">
            <div 
                className={ ` position-sticky mr-2 mt-2 top` }
                style={{ zIndex: 100 }}
            >
                <div 
                    className={` mt-2 position-absolute right btn btn-sm btn-${defaultFest !== JSON.stringify(festival) ? 'danger' : 'secondary opacity_5 untouchble'}`}
                    onClick={updateFestival} 
                >
                    <Icon icon="tick" className="mr-2" /> {__("Update Festival data")}
                </div>
            </div>
            <div className='d-flex justify-content-between align-items-center'>
                <div className='display-5 mb-3'>{ __(props.title || "") }</div>
            </div>
            <div className='row'>
                <div className='col-12 '> 
                    <Card interactive={true} className="p-4 mb-2">
                        <div className="lead mb-1">{__("Page of Festival rules")}</div>
                        <input
                            type="checkbox"
                            className="_checkbox"
                            checked={ festival.enabledRules || false }
                            onChange={ evt => onValueChange("enabledRules", evt.target.checked) }
                            value="1"
                            id="enabled_rules"
                        />
                        <label htmlFor="enabled_rules"></label>
                        
                    </Card> 
                    {
					    !festival.enabledRules
                            ?
                            null
                            :
                            <>
                                <Card className="p-4 mb-2">
                                    <div className="lead mb-1">{__("Default image")}</div>
                                    <div className="row">
                                        <div className=" col-12 ">
                                            <MediaChooser
                                                url={festival.defaultThumbnail!}
                                                prefix={"icon"}
                                                height={230}
                                                width={"100%"}
                                                padding={5}
                                                onChange={ onDefaultImage }
                                                id={ festival.defaultThumbnail! }
                                                isURLHide={ true }
                                                isDescr={ false }
                                                hideLib
                                                ID="headerImg"
                                                limitSize={ 4000000 }
                                            />
                                            <div className="small mt-1 text-right">{
                                                __("This is the header image for the home page.")}
                                            </div>
                                        </div> 
                                    </div>
                                </Card>			
                                <Card interactive={true} className="p-4 mb-2">
                                    <div className="lead mb-1">{__("Show rules page?")}</div>
                                    <input
                                        type="checkbox"
                                        className="_checkbox"
                                        checked={ festival.isShowReglament || false }
                                        onChange={ evt => onValueChange("isShowReglament", evt.target.checked) }
                                        value="1"
                                        id="is_show_reglament"
                                    />
                                    <label htmlFor="is_show_reglament"></label> 
                                </Card>
                                <Card className="p-4 mb-2" data-element="client_url">
                                    <div className="lead mb-1">{__("Content of description page")}</div>  
                                    <FieldInput 					
                                        vertical={ VerticalType.VERTICAL }
                                        editable
                                        value={
                                            festival.content   
                                            || 
                                            "--"
                                        }
                                        commentary={__("Content of this page put to «About» link.")}
                                        type={SCALAR_TYPES.TEXT}  
                                        onChange={ value => onValueChange("content", value) }
                                    />
                                </Card> {/*  */}
                                <Card className="p-4 mb-2" data-element="client_url">
                                      
                                    <FieldInput			
                                        vertical={ VerticalType.VERTICAL }
                                        editable
                                        value={
                                            festival.reglamentTitle  
                                            || 
                                            "--"
                                        }
                                        commentary={__('Set reglament title')}
                                        type={SCALAR_TYPES.STRING}  
                                        onChange={ value => onValueChange("reglamentTitle", value) }
                                    /> 
                                    <div className='mb-4' />
                                    <FieldInput 					
                                        vertical={ VerticalType.VERTICAL }
                                        editable
                                        value={
                                            festival.reglament  
                                            || 
                                            "--"
                                        }
                                        //placeholder={__('Content of reglament page')}
                                        commentary={__('Content of reglament page')}
                                        type={SCALAR_TYPES.TEXT}  
                                        onChange={ value => onValueChange("reglament", value) }
                                    /> 
                                </Card>

                                <Card interactive={false} className="p-4 mb-2" data-element="client_url"> 
                                    <FieldInput 	
                                        title={__("Sign color")}					
                                        vertical={ VerticalType.VERTICAL }
                                        editable
                                        value={ festival.color }
                                        commentary={ __('Typical color accents of the Festival') }
                                        type={SCALAR_TYPES.COLOR}  
                                        onChange={ value => onValueChange("color", value) }
                                    />
                                </Card>
                                <Card interactive={false} className="p-4 mb-2" data-element="vk,vk2,email,email2,phone,phone2"> 
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="layout-label-vert  mb-1">{__("Contacts")}</div> 
                                            <div className=" mb-1">{__("The contacts you specified will be listed on the pages of the Festival")}</div> 
                                            <FieldInput
                                                title={__("Link")}	 
                                                value={festival.link1}
                                                editable
                                                type={SCALAR_TYPES.STRING}  
                                                onChange={value => onValueChange("link1", value)}
                                            />
                                            <FieldInput
                                                title={__("Link alternative")}	 
                                                value={festival.link2}
                                                editable
                                                type={SCALAR_TYPES.STRING} 
                                                onChange={value => onValueChange("link2", value)}
                                            />
                                            <FieldInput
                                                title={__("VKontakte")}	 
                                                value={festival.vk}
                                                editable
                                                type={SCALAR_TYPES.STRING}  
                                                onChange={value => onValueChange("vk", value)}
                                            />
                                            <FieldInput
                                                title={__("VKontakte alternative")}	 
                                                value={festival.vk2}
                                                editable
                                                type={SCALAR_TYPES.STRING}  
                                                onChange={value => onValueChange("vk2", value)}
                                            />
                                            <FieldInput
                                                title={__("E-mail")}	 
                                                value={festival.email}
                                                editable
                                                type={SCALAR_TYPES.EMAIL} 
                                                onChange={value => onValueChange("email", value)}
                                            />
                                            <FieldInput
                                                title={__("E-mail alternative")} 
                                                value={festival.email2}
                                                editable
                                                type={SCALAR_TYPES.EMAIL} 
                                                onChange={value => onValueChange("email2", value)}
                                            />
                                            <FieldInput
                                                title={__("Telegramm")} 
                                                value={festival.telegramm}
                                                editable
                                                type={SCALAR_TYPES.STRING}  
                                                onChange={value => onValueChange("telegramm", value)}
                                            />
                                            <FieldInput
                                                title={__("Telegramm alternative")} 
                                                value={festival.telegramm2}
                                                editable
                                                type={SCALAR_TYPES.STRING} 
                                                onChange={value => onValueChange("telegramm2", value)}
                                            />
                                            <FieldInput 
                                                title={__("Phone")}	 
                                                value={festival.phone}
                                                className={` w-100 input dark form-control `}
                                                editable
                                                type={SCALAR_TYPES.PHONE}  
                                                onChange={value => onValueChange("phone", value)}
                                            />
                                            <FieldInput 
                                                title={__("Phone alternative")} 
                                                value={festival.phone2}
                                                className={` w-100 input dark form-control `}
                                                editable
                                                type={SCALAR_TYPES.PHONE} 
                                                onChange={value => onValueChange("phone2", value)}
                                            />
                                        </div>
                                    </div>
                                </Card>
                                <Card interactive={false} className="p-4 mb-2 pb-5" data-element="icon,default_member_thrumb">
                                    <div className="layout-label-vert  mb-1">{__("Icons")}</div>
                                    <div className="row">
                                        <div className=" col-12" data-element="icon">
                                            <div className="small mt-1">{__("Logotype")}</div>
                                            <MediaChooser
                                                url={festival.logotype!}
                                                prefix={"icon"}
                                                height={100}
                                                padding={0}
                                                onChange={ onIcon}
                                                id={festival.logotype!}
                                                isURLHide={true}
                                                isDescr={false}
                                                hideLib
                                                limitSize={200000}
                                            />
                                        </div> 
                                    </div>
                                </Card>

                                <Card interactive={true} className="p-4 mb-2">
                                    <div className="lead mb-1">{__("Show map of Members")}</div>
                                    <input
                                        type="checkbox"
                                        className="_checkbox"
                                        checked={ festival.isShowMap || false }
                                        onChange={ evt => onValueChange( "isShowMap", evt.target.checked ) }
                                        value="1"
                                        id="is_show_map"
                                    />
                                    <label htmlFor="is_show_map"></label>
                                    <small className="text-secondary" style={{ position:"absolute", marginTop:10 }}>
                                        {__("Interactive Russia region map in statistic footer")}
                                    </small>

                                    <div className="lead mb-1 mt-4">{__("Show Honnor hall")}</div>
                                    <input
                                        type="checkbox"
                                        className="_checkbox"
                                        checked={ festival.isShowLaureates || false }
                                        onChange={ evt => onValueChange( "isShowLaureates", evt.target.checked ) }
                                        value="1"
                                        id="isShowLaureates"
                                    />
                                    <label htmlFor="isShowLaureates"></label>
                                    <small className="text-secondary" style={{ position:"absolute", marginTop:10 }}>
                                        {__("Show|hide laureates block on main page")}
                                    </small>

                                    <div className="lead mb-1 mt-4">{__("Show education organizations list")}</div>
                                    <input
                                        type="checkbox"
                                        className="_checkbox"
                                        checked={ festival.isShowSchools || false }
                                        onChange={ evt => onValueChange( "isShowSchools", evt.target.checked ) }
                                        value="1"
                                        id="isShowSchools"
                                    />
                                    <label htmlFor="isShowSchools"></label>

                                    <div className="lead mb-1 mt-4">{__("Show Tracks")}</div>
                                    <input
                                        type="checkbox"
                                        className="_checkbox"
                                        checked={ festival.isShowTracks || false }
                                        onChange={ evt => onValueChange( "isShowTracks", evt.target.checked ) }
                                        value="1"
                                        id="isShowTracks"
                                    />
                                    <label htmlFor="isShowTracks"></label>
                                    <small className="text-secondary" style={{ position:"absolute", marginTop:10 }}>
                                        {__("Show|hide tracks block on main page")}
                                    </small>

                                    <div className="lead mb-1 mt-4">{__("Show Milestones")}</div>
                                    <input
                                        type="checkbox"
                                        className="_checkbox"
                                        checked={ festival.isMilestones || false }
                                        onChange={ evt => onValueChange( "isMilestones", evt.target.checked ) }
                                        value="1"
                                        id="isMilestones"
                                    />
                                    <label htmlFor="isMilestones"></label>
                                    <small className="text-secondary" style={{ position:"absolute", marginTop:10 }}>
                                        {__("Show|hide milestones block on main page")}
                                    </small>
                                </Card>	
                            </>
				    }
                </div>
            </div>
        </div>
  )
} 

export default MainPageForm